var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('b-row',[_c('b-col',{attrs:{"md":"10"}},[_c('page-breadcrumb',{staticClass:"mb-1",attrs:{"title":"Configs"}})],1)],1),_c('b-card',[_c('fomula-config-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }